import React, { Component } from 'react'
import SvgComponent from '../../core/SvgComponent'
import SvgFile from './SvgFile'

class IcProyugaLogo extends Component {
  render() {
    return <SvgComponent renderComponent={SvgFile} {...this.props} />
  }
}

export default IcProyugaLogo
